module.exports = "<div class=\"card {{cardVariant}} {{cardAlign}} {{cardInverse}}\">\n    <slot></slot>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/card/card.html
// module id = 21
// module chunks = 0